const selectedZoneReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_SELECTED_ZONES':
      return [...action.payload];
    default:
      return state;
  }
};

export default selectedZoneReducer;
